import { sanitizeCmsHtml } from '../sanitize-html';

const BLOCK_TAG = '(?:blockquote|h[1-6]|hr|li|ol|p|pre|ul)';
const BLOCK_OPEN_PATTERN = new RegExp(`<${BLOCK_TAG}\\b[^>]*>`, 'gi');
const BLOCK_CLOSE_PATTERN = new RegExp(`</${BLOCK_TAG}\\s*>`, 'gi');
const VOID_BLOCK_PATTERN = /<hr\b[^>]*\/?>/gi;
const IMPORTED_BLOCK_CLOSE_PATTERN = /<\/(?:article|aside|div|footer|header|main|nav|section)\s*>/gi;
const LEADING_OR_TRAILING_BREAK_PATTERN = /^(?:<br\s*\/?>)+|(?:<br\s*\/?>)+$/gi;
const REPEATED_BREAK_PATTERN = /(?:<br\s*\/?>\s*){2,}/gi;
const BREAK_PATTERN = /<br\s*\/?>/gi;
const ALIGNMENT_PATTERN = /<(?:h[1-6]|p)\b[^>]*\bstyle="text-align: (left|center|right|justify)"/i;

type HeadingLevel = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

function headingInlineHtml(html: unknown): { alignment?: string; inlineHtml: string } {
  // Preserve common imported block boundaries locally; the shared sanitizer remains general.
  const source = typeof html === 'string' ? html : '';
  const withImportedBoundaries = source.replace(IMPORTED_BLOCK_CLOSE_PATTERN, '<br>');
  const sanitized = sanitizeCmsHtml(withImportedBoundaries);
  return {
    alignment: ALIGNMENT_PATTERN.exec(sanitized)?.[1],
    inlineHtml: sanitized
      .replace(VOID_BLOCK_PATTERN, '<br>')
      .replace(BLOCK_CLOSE_PATTERN, '<br>')
      .replace(BLOCK_OPEN_PATTERN, '')
      .replace(REPEATED_BREAK_PATTERN, '<br>')
      .replace(LEADING_OR_TRAILING_BREAK_PATTERN, ''),
  };
}

export function semanticHeadingHtml(html: string, tag: HeadingLevel): string {
  const { alignment, inlineHtml } = headingInlineHtml(html);
  const flattenedHtml = inlineHtml.replace(BREAK_PATTERN, ' ');
  const meaningfulText = flattenedHtml
    .replace(/<[^>]*>/g, '')
    .replace(/(?:&nbsp;|&#160;|&#xa0;)/gi, '')
    .trim();
  if (meaningfulText === '') {
    return '';
  }
  const style = alignment ? ` style="text-align: ${alignment}"` : '';
  return `<${tag}${style}>${flattenedHtml}</${tag}>`;
}

export function normalizeHeadingEditorHtml(html: unknown): string {
  const { alignment, inlineHtml } = headingInlineHtml(html);
  const style = alignment ? ` style="text-align: ${alignment}"` : '';
  return `<p${style}>${inlineHtml.replace(BREAK_PATTERN, ' ')}</p>`;
}
